<template>
  <div class="w-full" v-if="iframeBase">
      <cabecera-web></cabecera-web>
      <div class="w-full px-5 mx-auto">
        <iframe-viewer class="w-full max-w-screen-xl" :iframeSrc="iframeSrc" ></iframe-viewer>
      </div>
  </div>  
</template>
<script>
import IframeViewer from '@/components/IframeViewer'
import CabeceraWeb from "@/components/Cabecera"
export default {
  data(){
    return {
      // iframeBase:'https://ticket.kutxabank.es/biziberriz/agencias/public/janto/main.php?Nivel=menuInicioAgencias&Idioma='
    }
  },
  computed: {
    iframeBase(){
      const bonoActual = this.$store.state.bonoActual

      return bonoActual.iframeAdmin
    },
    iframeSrc(){
      return this.iframeBase + this.$i18n.locale.toUpperCase()
    }
  },
  components: {
    IframeViewer,
    CabeceraWeb
  }
}
</script>